module.exports = __webpack_public_path__ + "img/shibcoin-bg.c854a20a.svg";